import { render } from "./Routes.vue?vue&type=template&id=d5375902&ts=true"
import script from "./Routes.vue?vue&type=script&lang=ts"
export * from "./Routes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__